import type { CaptainBillingAccount } from "./types";

export type CaptainBalanceState = "healthy" | "low" | "usedUp";

export function getCaptainBalanceState(
  account: Pick<CaptainBillingAccount, "availableTokens" | "monthlyCapTokens" | "lowBalanceThresholdPercent">,
): CaptainBalanceState {
  if (account.availableTokens <= 0) return "usedUp";
  if (
    account.monthlyCapTokens > 0 &&
    account.availableTokens <= (account.monthlyCapTokens * account.lowBalanceThresholdPercent) / 100
  )
    return "low";
  return "healthy";
}
